/* ============================================================
   Pills & Powders — /vote capture  (Stage-1 lead layer)

   Origin: Haakon's vote-capture.js (Klaviyo). Wired by Emre/Claude
   2026-06-05 with two corrections, documented inline:
     [FIX 1] form selector was ".pp-vote__form" — the real live class
             is ".pp-vote__modal-form" (sections/pp-vote-real.liquid).
             The original selector matched nothing, so the script
             would return early and never run.
     [FIX 2] the countable "Placed Vote" event no longer depends on a
             global `klaviyo` (there is NO Klaviyo app-embed on the
             theme, so window.klaviyo may be undefined). It is sent via
             Klaviyo's client REST endpoint, same as the subscribe — so
             Jesse's hard "votes must be countable" requirement holds
             whether or not onsite klaviyo.js is present. Onsite
             identify is still called when available (session link only).
     [ADD 1] (Haakon 2026-06-12) Cookies for thank-you page email/name.
     [ADD 2] (Haakon 2026-06-13) Wait for Make before redirecting.
             Make creates the GoAffPro affiliate and returns the real
             referral link. We pass it through the redirect URL so the
             thank-you page reads it instantly — no timing issue.
             The Klaviyo POSTs (keepalive) complete independently.
             fireHook / Promise.allSettled removed — Make fetch is the
             single and only thing that triggers ppOnVoteCaptured.

   Data model (unchanged from Haakon / klaviyo-schema-vote-funnel.md):
     profile properties : voted_product, vote_source
     event              : "Placed Vote" { product, source }
     list               : SHOPIFY /VOTE LIST  (XP3zhd)
     public site id     : VVJzZj

   Live DOM (verified in sections/pp-vote-real.liquid):
     form              .pp-vote__modal-form
     chosen product    [data-vote-chosen]
     name              #pp-vote-name
     email             #pp-vote-email
     consent checkbox  .pp-vote__check input[type=checkbox]
     success panel     [data-vote-success]
   ============================================================ */

(function () {
  var LIST_ID    = "XP3zhd";
  var PUBLIC_KEY = "VVJzZj";
  var REVISION   = "2025-07-15";

  var form = document.querySelector(".pp-vote__modal-form");
  if (!form) return;

  function getVoteSource() {
    var p = new URLSearchParams(window.location.search);
    return (
      p.get("utm_source") ||
      (document.cookie.match(/(?:^|;\s*)pp_ref=([^;]+)/) || [])[1] ||
      "direct"
    );
  }

  function klaviyoClient(path, body) {
    return fetch("https://a.klaviyo.com/client/" + path + "/?company_id=" + PUBLIC_KEY, {
      method: "POST",
      headers: { "Content-Type": "application/json", revision: REVISION },
      body: JSON.stringify(body),
      keepalive: true
    });
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    var email   = (document.querySelector("#pp-vote-email") || {}).value;
    var name    = (document.querySelector("#pp-vote-name") || {}).value;
    var chosen  = document.querySelector("[data-vote-chosen]");
    var product = chosen ? (chosen.textContent || "").trim() : "";
    var consentEl = document.querySelector(".pp-vote__check input[type=checkbox]");
    var consent = consentEl ? consentEl.checked : false;
    var source  = getVoteSource();
    email = email ? email.trim() : "";
    name  = name ? name.trim() : "";

    if (!email || !product || !consent) {
      console.warn("[vote] missing email/product/consent", { email: email, product: product, consent: consent });
      return;
    }

    // [ADD 1] Persist email + name for the thank-you page (15-min cookies).
    document.cookie = "pp_vote_email=" + encodeURIComponent(email) + "; path=/; max-age=900; SameSite=Lax";
    document.cookie = "pp_vote_name=" + encodeURIComponent(name) + "; path=/; max-age=900; SameSite=Lax";

    // Optional onsite identify.
    if (typeof klaviyo !== "undefined" && klaviyo && typeof klaviyo.identify === "function") {
      try { klaviyo.identify({ email: email, first_name: name || undefined, voted_product: product, vote_source: source }); } catch (_) {}
    }

    // [ADD 3] (Romain 2026-06-18) Romain's Lead tracking event. Fires once per
    // successful submit, ALONGSIDE the Klaviyo "Placed Vote" capture below, for
    // both a card vote and a write-in suggestion: `product` is read from
    // [data-vote-chosen], which holds the typed suggestion on a write-in. Guarded
    // so it never throws if Shopify.analytics is undefined.
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
        Shopify.analytics.publish("vote_submitted", {
          product_voted: product,
          email: email,
          first_name: name
        });
      }
    } catch (err) { console.warn("[vote] vote_submitted publish failed", err); }

    // 1) Klaviyo: countable vote event (keepalive — survives redirect).
    klaviyoClient("events", {
      data: {
        type: "event",
        attributes: {
          properties: { product: product, source: source },
          metric: { data: { type: "metric", attributes: { name: "Placed Vote" } } },
          profile: { data: { type: "profile", attributes: { email: email, first_name: name || undefined } } }
        }
      }
    }).catch(function (err) { console.warn("[vote] event failed", err); });

    // 2) Klaviyo: subscribe with consent + profile properties (keepalive).
    klaviyoClient("subscriptions", {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Factory Vote",
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
                first_name: name || undefined,
                subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } },
                properties: { voted_product: product, vote_source: source }
              }
            }
          }
        },
        relationships: { list: { data: { type: "list", id: LIST_ID } } }
      }
    }).catch(function (err) { console.warn("[vote] subscribe failed", err); });

    // 3) Show success panel immediately so voter sees feedback while Make runs.
    var success = document.querySelector("[data-vote-success]");
    if (success) success.hidden = false;

    // [ADD 2] Call Make — wait for the real referral link before redirecting.
    // This is the ONE AND ONLY place that calls ppOnVoteCaptured.
    // Klaviyo POSTs above use keepalive and complete independently.
    fetch("https://hook.eu1.make.com/sq93uj54r3wokc1ha2ul18qjthksvk9t", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: email, firstname: name })
    })
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        var d = null;
        try { d = JSON.parse(txt); } catch (e) {}
        var code = (d && (d.referalCode || d.referralCode || d.ref || d.link || d.url)) || "";
        window.ppOnVoteCaptured({ email: email, product: product, source: source, referralLink: code });
      })
      .catch(function () {
        window.ppOnVoteCaptured({ email: email, product: product, source: source, referralLink: "" });
      });

  });
})();